import { ThemeToggle } from "./ThemeToggle";

export function AuthLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen">
      {/* Left brand panel — gradient tracks --primary so brand color follows it */}
      <div
        className="hidden lg:flex lg:w-1/2 relative overflow-hidden"
        style={{
          background:
            "linear-gradient(to bottom right, var(--primary), color-mix(in oklab, var(--primary) 80%, white) 50%, color-mix(in oklab, var(--primary) 60%, white))",
        }}
      >
        {/* Decorative geometric pattern */}
        <div className="absolute inset-0 opacity-10">
          <svg className="h-full w-full" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <defs>
              <pattern id="auth-grid" width="40" height="40" patternUnits="userSpaceOnUse">
                <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="1" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#auth-grid)" />
          </svg>
        </div>
        <div className="relative z-10 flex flex-col justify-center px-12 xl:px-16">
          <h1 className="font-display text-4xl xl:text-5xl font-bold text-white leading-tight">
            Waypoint
          </h1>
          <p className="mt-4 text-lg text-white/80 max-w-md leading-relaxed">
            Practice high-stakes conversations with AI stakeholders. Get better at every meeting
            that matters.
          </p>
        </div>
      </div>

      {/* Right form panel */}
      <div className="flex w-full lg:w-1/2 flex-col bg-background">
        {/* Mobile brand header */}
        <div className="flex items-center justify-between p-4 lg:justify-end">
          <h2 className="font-display text-xl font-bold text-primary lg:hidden">Waypoint</h2>
          <ThemeToggle />
        </div>

        {/* Centered form */}
        <div className="flex flex-1 items-center justify-center px-4 pb-12">
          <div className="w-full max-w-md">{children}</div>
        </div>
      </div>
    </div>
  );
}
